import { MyApp } from '$app/app.component';
import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { HeaderComponent } from './header/header';
@NgModule({
	declarations: [HeaderComponent],
	imports: [IonicModule.forRoot(MyApp)],
	exports: [HeaderComponent]
})
export class ComponentsModule { }



// WEBPACK FOOTER //
// ./src/components/components.module.ts